import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Popconfirm, Flex, Modal, message } from "antd";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
//components
//actions
import { updateAccessShop } from "../../../../store/branch/branch.action";
import { deleteStaff } from "../../../../store/staff/staff.action";
//selector
import { detailSelector } from "../../../../store/branch/branch.selector";

//function
//str
const { confirm } = Modal;
const BranchStaffListingRemove = ({ item, loading, setLoading }) => {
  // -------------------------- VAR ----------------------------
  const fullName = item?.fullName;
  const branchId = item?.branch;
  const staff = item?.staffId;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX -------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailSelector);
  const coop = branch?.coop;
  // -------------------------- FUNCTION ---------------------
  const showConfirm = () => {
    confirm({
      title: ` Do you want to remove "${fullName}" out of this branch?`,
      icon: <ExclamationCircleFilled />,
      // content: "Giao dịch sẽ bị xoá khỏi danh sách thanh toán",
      onOk() {
        handleOk();
      },
      onCancel() {
        handleCancel();
      },
      okButtonProps: {
        className: "ok-btn-style",
        danger: true,
      },
      cancelButtonProps: {
        className: "cancel-btn-style",
      },
      okText: "Yes",
      cancelText: "No",
    });
  };

  const handleCancel = () => {
    console.log("cancelled");
  };
  const handleOk = () => {
    // console.log("ok");
    // setLoading(true);
    const newCoop = coop?.filter((c) => c !== item?.id) || [];
    const staff = {
      id: item.staffId,
    };
    dispatch(
      updateAccessShop({ branchId: branchId, coop: newCoop }, (res) => {
        if (res.status === 200) {
          dispatch(
            deleteStaff({ staff }, () => {
              setLoading(false);
            })
          );
        } else {
          // message.error(res?.data);
          console.error(res?.data);
          setLoading(false);
        }
      })
    );
  };

  // -------------------------- EFFECT ------------------------
  // -------------------------- RENDER ------------------------
  // -------------------------- MAIN ---------------------------
  return (
    <Button
      loading={loading}
      danger
      type="default"
      onClick={showConfirm}
      icon={<DeleteOutlined />}
    />
  );
};
export default BranchStaffListingRemove;
